import React from "react";
import {ChartOptions, ChartResults} from "../../../actions/queryBuilderApi";
import {StackedBarChart} from "./charts/StackedBarChart";
import { BarChart } from "./charts/BarChart";
import {ChartType} from "./types/ChartType";
import styles from './Visualisations.module.scss'
import {LineChart} from "./charts/LineChart";
import {IDENTIFIER_CHOICE, SUM_CHOICE} from "../../../components/query-builder/components/ValueDialog";

export type ChartProps = {
    chartOptions: ChartOptions
    defaultChartOptions?: ChartOptions
    defaultResults?: ChartResults
    aggtype?: string
    remainingFields: number
    setSortDisabled(disabled: boolean): void
}

export const Chart = ({chartOptions, defaultChartOptions, defaultResults, aggtype, remainingFields, setSortDisabled}: ChartProps) => {

    const requiresAllFields = aggtype !== IDENTIFIER_CHOICE.value && aggtype !== SUM_CHOICE.value

    let chartContent

    if (requiresAllFields && remainingFields > 0) {
        chartContent = (
            <div>When utilising minimum, maximum, or average values on this chart, it is necessary to use all fields
                from the original query.
            </div>
        )
    } else {
        switch (chartOptions.chartType) {
            case ChartType.BAR:
                chartContent = <BarChart chartOptions={chartOptions}
                                         defaultChartOptions={defaultChartOptions}
                                         defaultResults={defaultResults}/>
                break
            case ChartType.STACKED_BAR:
                chartContent = <StackedBarChart chartOptions={chartOptions}/>
                break
            case ChartType.LINE:
                chartContent = <LineChart chartOptions={chartOptions} setSortDisabled={setSortDisabled}/>
                break
            default:
                chartContent = null
        }
    }

    return <div className={styles["chart-area"]}>{chartContent}</div>

}